unit View.Tipos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewTiposList = class(TForm)
    btNew: TButton;
    TiposDataset: TXDataWebDataSet;
    TiposDatasetid: TIntegerField;
    TiposDatasetaliado_id: TIntegerField;
    TiposDatasetdata_base_id: TIntegerField;
    TiposDatasetnome: TStringField;
    TiposDatasetcodigo_sped: TStringField;
    TiposDatasetcodigo_interno: TIntegerField;
    TiposDatasetexcluido: TBooleanField;
    TiposDatasetinclusao: TDateTimeField;
    TiposDatasetalteracao: TDateTimeField;
    TiposDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewTiposList: TFViewTiposList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewTiposList }

procedure TFViewTiposList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewTiposList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewTiposList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewTiposList, AElementID, Result, @AfterCreate);
end;

procedure TFViewTiposList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewTiposList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewTiposList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      TiposDataset.Connection.Model.DefaultSchema.FindEntityType(TiposDataset.EntitySetName),
      TiposDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewTiposList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('tipos', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    TiposDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewTiposList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.tipos.list.pagination.info');
  btNew := TButton.Create('view.tipos.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.tipos.list.table');
  cbPageSize := TComboBox.Create('view.tipos.list.cbPageSize');
  edSearch := TEdit.Create('view.tipos.list.search');
  lcPaginator := TListControl.Create('view.tipos.list.pagination');
  TiposDataset := TXDataWebDataSet.Create(Self);
  TiposDatasetid := TIntegerField.Create(Self);
  TiposDatasetaliado_id := TIntegerField.Create(Self);
  TiposDatasetdata_base_id := TIntegerField.Create(Self);
  TiposDatasetnome := TStringField.Create(Self);
  TiposDatasetcodigo_sped := TStringField.Create(Self);
  TiposDatasetcodigo_interno := TIntegerField.Create(Self);
  TiposDatasetexcluido := TBooleanField.Create(Self);
  TiposDatasetinclusao := TDateTimeField.Create(Self);
  TiposDatasetalteracao := TDateTimeField.Create(Self);
  TiposDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  TiposDataset.BeforeLoadDFMValues;
  TiposDatasetid.BeforeLoadDFMValues;
  TiposDatasetaliado_id.BeforeLoadDFMValues;
  TiposDatasetdata_base_id.BeforeLoadDFMValues;
  TiposDatasetnome.BeforeLoadDFMValues;
  TiposDatasetcodigo_sped.BeforeLoadDFMValues;
  TiposDatasetcodigo_interno.BeforeLoadDFMValues;
  TiposDatasetexcluido.BeforeLoadDFMValues;
  TiposDatasetinclusao.BeforeLoadDFMValues;
  TiposDatasetalteracao.BeforeLoadDFMValues;
  TiposDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewTiposList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_sped';
      Title := 'codigo_sped';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    TiposDataset.SetParentComponent(Self);
    TiposDataset.Name := 'TiposDataset';
    TiposDataset.EntitySetName := 'Tipos';
    TiposDataset.Connection := DMConnection.ApiConnection;
    TiposDataset.Left := 72;
    TiposDataset.Top := 144;
    TiposDatasetid.SetParentComponent(TiposDataset);
    TiposDatasetid.Name := 'TiposDatasetid';
    TiposDatasetid.FieldName := 'id';
    TiposDatasetid.Required := True;
    TiposDatasetaliado_id.SetParentComponent(TiposDataset);
    TiposDatasetaliado_id.Name := 'TiposDatasetaliado_id';
    TiposDatasetaliado_id.FieldName := 'aliado_id';
    TiposDatasetaliado_id.Required := True;
    TiposDatasetdata_base_id.SetParentComponent(TiposDataset);
    TiposDatasetdata_base_id.Name := 'TiposDatasetdata_base_id';
    TiposDatasetdata_base_id.FieldName := 'data_base_id';
    TiposDatasetdata_base_id.Required := True;
    TiposDatasetnome.SetParentComponent(TiposDataset);
    TiposDatasetnome.Name := 'TiposDatasetnome';
    TiposDatasetnome.FieldName := 'nome';
    TiposDatasetnome.Required := True;
    TiposDatasetnome.Size := 255;
    TiposDatasetcodigo_sped.SetParentComponent(TiposDataset);
    TiposDatasetcodigo_sped.Name := 'TiposDatasetcodigo_sped';
    TiposDatasetcodigo_sped.FieldName := 'codigo_sped';
    TiposDatasetcodigo_sped.Size := 255;
    TiposDatasetcodigo_interno.SetParentComponent(TiposDataset);
    TiposDatasetcodigo_interno.Name := 'TiposDatasetcodigo_interno';
    TiposDatasetcodigo_interno.FieldName := 'codigo_interno';
    TiposDatasetcodigo_interno.Required := True;
    TiposDatasetexcluido.SetParentComponent(TiposDataset);
    TiposDatasetexcluido.Name := 'TiposDatasetexcluido';
    TiposDatasetexcluido.FieldName := 'excluido';
    TiposDatasetinclusao.SetParentComponent(TiposDataset);
    TiposDatasetinclusao.Name := 'TiposDatasetinclusao';
    TiposDatasetinclusao.FieldName := 'inclusao';
    TiposDatasetalteracao.SetParentComponent(TiposDataset);
    TiposDatasetalteracao.Name := 'TiposDatasetalteracao';
    TiposDatasetalteracao.FieldName := 'alteracao';
    TiposDatasetexclusao.SetParentComponent(TiposDataset);
    TiposDatasetexclusao.Name := 'TiposDatasetexclusao';
    TiposDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := TiposDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    TiposDataset.AfterLoadDFMValues;
    TiposDatasetid.AfterLoadDFMValues;
    TiposDatasetaliado_id.AfterLoadDFMValues;
    TiposDatasetdata_base_id.AfterLoadDFMValues;
    TiposDatasetnome.AfterLoadDFMValues;
    TiposDatasetcodigo_sped.AfterLoadDFMValues;
    TiposDatasetcodigo_interno.AfterLoadDFMValues;
    TiposDatasetexcluido.AfterLoadDFMValues;
    TiposDatasetinclusao.AfterLoadDFMValues;
    TiposDatasetalteracao.AfterLoadDFMValues;
    TiposDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
